import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllSubjectDataService = async (
  pageNumber,
  pageSize,
  access_token,
  searchedSubject = "",
  activeTab,
  selectedSite,
) => {
  const data = {
    siteId: selectedSite ? selectedSite : "", // Use selectedSite if provided, otherwise null
  };
  try {
    // Build URL and include isActive only when activeTab is not an empty string
    let url = `${api}/Patient/GetPatientDataPagination?pageNumber=${
      searchedSubject !== "" ? 1 : pageNumber
    }&pageSize=${pageSize}&filter=${searchedSubject}`;
    if (activeTab !== "") {
      url += `&isActive=${activeTab}`;
    }

    return axios.post(
      url,
      selectedSite ? data : null, // Include data only if selectedSite is provided
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const fetchAllSiteDataService = async (access_token, userId) => {
  try {
    return axios.get(`${api}/Patient/GetSiteData?userId=${userId}`, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const getSubjectLoadDataService = (access_token, data) => {
  try {
    return axios.post(`${api}/Question/CreatePatientVisitOnload`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const saveSubjectDataService = (
  access_token,
  data,
  userId,
  selectedLanguage,
) => {
  try {
    let url = `${api}/Question/PostPatientVisit?UserId=${userId}`;
    if (selectedLanguage !== "") {
      url += `&LanguagePick=${selectedLanguage}`;
    }

    return axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const getSubjectDetailsByIdService = async (
  access_token,
  id,
  cultureCode,
  data,
) => {
  try {
    return axios.post(
      `${api}/Patient/EditOnload?PatientGuid=${id}&CurrentSiteUserCultureCode=${cultureCode}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getOnLoadDataForRandomizationTreatmentErrorService = async (
  access_token,
  id,
  cultureCode,
) => {
  try {
    return axios.get(
      `${api}/Patient/RegisterEnrollmentTreatmentErrorOnload?PatientId=${id}&CurrentSiteUserCultureCode=${cultureCode}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getPatientVisitDataService = async (access_token, patientId) => {
  try {
    return axios.get(
      `${api}/PatientVisit/IndexAccordian?PatientId=${patientId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getPatientDiaryDetailsService = async (
  access_token,
  patientId,
  questionnaireId,
  visitId,
  userId,
  cultureCode,
) => {
  try {
    return axios.get(
      `${api}/Patient/GetDiaryGrid?PatientId=${patientId}&QuestionnaireId=${questionnaireId}&VisitId=${visitId}&UserId=${userId}&CurrentSiteUserCultureCode=${cultureCode}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getSubjectVisitEntryDetailsService = async (
  access_token,
  id,
  cultureCode,
) => {
  try {
    return axios.get(
      `${api}/DiaryEntries/Details?Id=${id}&CurrentSiteUserCultureCode=${cultureCode}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getChoicesForQuestions = async (questionId) => {
  try {
    return axios.get(
      `https://genesisqbapi.augursapps.com/app/Choice/GetChoicesByQuestion?QuestionId=${questionId}`,
    );
  } catch (err) {
    return err;
  }
};

export const getDrugKitsDataService = async (
  access_token,
  patientId,
  cultureCode,
) => {
  try {
    return axios.get(
      `${api}/PatientVisitDrug/PatientDrugKits?patientId=${patientId}&CurrentSiteUserCultureCode=${cultureCode}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getKitNumberService = async (
  access_token,
  id,
  patientVisitId,
  cultureCode,
) => {
  try {
    return axios.get(
      `${api}/Patient/GetKitsForVisit?patientId=${id}&patientVisitId=${patientVisitId}&CurrentSiteUserCultureCode=${cultureCode}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getPatientVisitIdByService = async (access_token, id, visitId) => {
  try {
    return axios.get(
      `${api}/Patient/GetPatientVisitIdByPatientAndVisit?patientId=${id}&visitid=${visitId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const registerRandomizationAndErrorService = (
  access_token,
  cultureCode,
  data,
) => {
  try {
    return axios.post(
      `${api}/Patient/RegisterEnrollmentTreatmentError?CurrentSiteUserCultureCode=${cultureCode}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getOnLoadDataServiceForUnblindSubject = async (
  access_token,
  id,
  cultureCode,
  roleId,
) => {
  try {
    return axios.get(
      `${api}/Patient/UnblindOnload?id=${id}&CurrentSiteUserCultureCode=${cultureCode}&UserId=${roleId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const postUnblindSubject = (access_token, roleId, cultureCode, data) => {
  try {
    return axios.post(
      `${api}/Patient/UnblindPost?CurrentSiteUserCultureCode=${cultureCode}&userId=${roleId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getOnLoadOverrideRandomizationService = async (
  access_token,
  id,
  cultureCode,
) => {
  try {
    return axios.get(
      `${api}/Patient/OverrideRandomizationOnload?id=${id}&CurrentSiteUserCultureCode=${cultureCode}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const postOverrideRandomization = (access_token, data) => {
  try {
    return axios.post(`${api}/Patient/OverrideRandomization`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};
